module.exports = __webpack_public_path__ + "img/logo.353ca03a.png";